<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" md="6" lg="5" xl="2">
                            <v-text-field hide-details clearable dense outlined type="date" label="Date to" v-model="filter.date"></v-text-field>
                        </v-col>  -->

            <v-col cols="12" lg="3">
              <v-text-field
                hide-details
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              lg="2"
              class="mt-7"
              style="padding-top:5px;"
              :class="$vuetify.breakpoint.mobile ? 'mb-2' : ''"
            >
              <v-btn
                color="green_button"
                class="btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <!-- <v-col
              cols="12"
              lg="2"
              class="mt-7"
              style="padding-top:5px;"
              v-if="$role.restricAccess($route.name, 'add')"
            >
              <v-btn color="green_button" class="btn-block" @click="modalForm"
                >Add prize</v-btn
              >
            </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.minimumbet`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.minimumbet | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.win_straight`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.win_straight | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.win_ramble`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.win_ramble | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.win_repetition`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.win_repetition | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.consolation_amount`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.consolation_amount | toNumberWithDecimal }}</template
                >

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn
                    color="info"
                    block
                    dark
                    small
                    @click="findData(item)"
                    :disabled="isEditButtonDisabled(item)"
                  >
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="550px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update prizes</span>
            <span v-else>Create prizes</span>
          </v-card-title>

          <v-card-text>
            <v-row dense class="pt-6">
              <v-col cols="12" lg="12" class="span-label">
                <span>Amount</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.minimumbet"
                  label="Amount"
                  :error-messages="formerror.minimumbet"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Region</span>
                <v-select
                  class="regular-field"
                  dense
                  clearable
                  @change="searchArea"
                  :items="drawregionlist"
                  item-value="id"
                  item-text="region_name"
                  label="Region"
                  v-model="form.region_id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Area</span>
                <v-select
                  class="regular-field"
                  dense
                  clearable
                  @change="getdrawlist"
                  :items="drawarealist"
                  item-value="id"
                  item-text="name"
                  label="Area"
                  v-model="form.zone_id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Draw</span>
                <v-select
                  :items="draw_list"
                  item-text="name"
                  item-value="id"
                  dense
                  class="regular-field"
                  v-model="form.draw_id"
                  label="Draw"
                  :error-messages="formerror.draw_id"
                  @change="getDrawData($event)"
                ></v-select>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Straight</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.win_straight"
                  label="Straight"
                  :error-messages="formerror.win_straight"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Rambol</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.win_ramble"
                  label="Rambol"
                  :error-messages="formerror.win_ramble"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Repetition</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.win_repetition"
                  label="Repetition"
                  :error-messages="formerror.win_repetition"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Consolation</span>
                <v-textarea
                  rows="5"
                  class="regular-field"
                  v-model="form.consolation_amount"
                >
                </v-textarea>
              </v-col>
              <!-- <v-col cols="12" lg="6">
                                <v-select :items="zone_list" item-text="name" item-value="id" dense outlined v-model="form.zone_id" label="Area" :error-messages="formerror.draw_id"></v-select>
                            </v-col> -->
              <!-- <v-col cols="12" lg="6">
                                <v-text-field dense outlined v-model="form.consolation_amount" label="Consolation" :error-messages="formerror.consolation_amount"></v-text-field>
                            </v-col> -->
              <!-- <v-col cols="12" lg="6">
                                <v-checkbox dense v-model="form.is_consolation" label="Is consolation?"></v-checkbox>
                            </v-col> -->
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="actionButtons">
            <v-row no-gutters>
              <v-col cols="12" lg="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="confirmPopup"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'delete')"
                  ><v-btn
                    color="delete_button"
                    class="float-right mr-3"
                    dark
                    :loading="isLoadingBtnDelete"
                    @click="deleteData(form.id)"
                    v-if="modalUpdate"
                    >Delete</v-btn
                  ></span
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <section>
      <v-dialog
        v-model="dialogConfirm"
        max-width="450"
        :style="{ zIndex: 200 }"
        @keydown.esc="cancel"
        persistent
      >
        <v-card>
          <v-toolbar dark color="info" dense flat>
            <v-toolbar-title class="text-body-2 font-weight-bold text-white">
              Please confirm
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12 text-center" lg="12">
                <h2>Override code</h2>
                <h5>Please contact tech admin for override code</h5>
                <v-text-field
                  single-line
                  solo
                  v-model="form.verificationcode"
                  placeholder="Override code"
                  :append-icon="
                    value ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                  "
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  style="font-size:15px"
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              class="body-2 font-weight-bold"
              @click="dialogConfirm = false"
              >Back</v-btn
            >
            <v-btn
              color="info"
              class="body-2 font-weight-bold"
              @click="updateData"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      
    </section>
    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      value: String,
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      dialogConfirm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          align: " d-none",
        },
        {
          text: "Draw",
          value: "draw_name",
          name: "draw_name",
        },
        // {
        //   text: "Region",
        //   value: "region_name",
        //   name: "region_name",
        // },
        // {
        //   text: "Area",
        //   value: "name",
        //   name: "name",
        // },
        // { text: 'Area', value: 'name', name: 'name', sortable: false, searchable: true},
        {
          text: "Bet amount",
          value: "minimumbet",
          name: "minimumbet",
        },
        {
          text: "Straight",
          value: "win_straight",
          name: "win_straight",
        },
        {
          text: "Rambol",
          value: "win_ramble",
          name: "win_ramble",
        },
        // {
        //   text: "Repetition",
        //   value: "win_repetition",
        //   name: "win_repetition",
        // },
        // { text: 'Min. bet consolation', value: 'consolation_amount', name: 'consolation_amount', sortable: false, searchable: false},
        // {
        //   text: "Actions",
        //   value: "actions",
        //   width: "10%",
        // },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      form: new this.$Form({
        id: null,
        consolation_amount: null,
        draw_id: null,
        draw_name: null,
        estimated_prize_pot: null,
        hidden_inc_percent: null,
        hidden_prize_pot: null,
        inc_percent: null,
        is_consolation: null,
        minimumbet: null,
        name: null,
        next_percent: null,
        pot: "regular",
        potprize: null,
        prize_pot: null,
        win_ramble: null,
        win_straight: null,
        verificationcode: null,
        region_id: null,
        zone_id: null,
        win_repetition: null,
      }),
      drawarealist: [],
      drawregionlist: [],
      draw_list: null,
      zone_list: null,
    };
  },
  methods: {
    async confirmPopup() {
      this.dialogConfirm = true;
    },
    isEditButtonDisabled(data) {
      if (this.$store.state.currentUser.agent_data.id == data.agent_id) {
        return false;
      }
      return true;
    },
    getDrawData(e) {
      let data = this.$_.filter(this.draw_list, function(x) {
        return x.id == e;
      })[0];
      if (data) {
        this.form.zone_id = data.zone_id;
      }
    },
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.formerror = {};
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
      this.searchRegion();
      this.searchArea();
      this.getdrawlist();
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_PRIZES"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          this.$Swal.fire(
            "Success!",
            "Record has been successfully added.",
            "success"
          );
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      console.log(this.form);
      this.modalUpdate = true;
      this.dialogForm = true;
      this.searchRegion();
      this.searchArea();
      this.getdrawlist();
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_PRIZES") + "/" + this.form.id)
        .then((data) => {
          if (data.data == "error") {
            this.isLoadingBtn = false;
            this.$toast.fire({ icon: "error", title: "Override code error" });
          } else {
            this.isLoadingBtn = false;
            this.dialogConfirm = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully updated.",
            });
          }
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
     async deleteData(id){
      this.isLoadingBtnDelete = true;
      if(
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ){
        this.form
          .delete(this.$_CONFIG.api("API_PRIZES") + "/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api("API_PRIZES")) + "earch";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    async drawlist() {
      let response = await this.$axios.get(this.$_CONFIG.api() + "/draw/list");
      this.draw_list = response.data;
    },
    // async zonelist() {
    //   let response = await this.$axios.get(
    //     this.$_CONFIG.api() + "/allzonelist"
    //   );
    //   this.zone_list = response.data;
    // },
    searchArea() {
      this.form
        .post(this.$_CONFIG.api() + "/drawarea")
        .then((res) => {
          this.drawarealist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchRegion() {
      this.form
        .post(this.$_CONFIG.api() + "/drawregion")
        .then((res) => {
          this.drawregionlist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getdrawlist() {
      this.form
        .post(this.$_CONFIG.api() + "/filterdrawresult")
        .then((res) => {
          this.draw_list = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getDataFromApi();
    this.getdrawlist();
    this.searchRegion();
  },
  mounted() {},
};
</script>
<style scoped></style>